import axios from 'axios';
import config from '../config/config';
import {
    SUPPORTER_PROJECT_REQUEST_DATA,
    SUPPORTER_PROJECT_RECEIVE_DATA,
    SUPPORTER_PROJECT_RECEIVE_NOT_FOUND,
    SUPPORTER_PROJECT_TOGGLE_BOOLEAN_VALUE,
    SUPPORTER_PROJECT_CHANGE_VALUE,
    SUPPORTER_PROJECT_SEND_SAVE,
    SUPPORTER_PROJECT_RECEIVE_SAVE,
    SUPPORTER_PROJECT_RECEIVE_SAVE_ERROR,
    SUPPORTER_PROJECT_EDIT, SUPPORTER_PROJECT_TOGGLE_ITEM_VALUE, SUPPORTER_PROJECT_SET_ITEM_VALUE
} from '../config/actions';
import EventBus from "../helpers/EventBus";

export function getSupporterProject(id) {
    return dispatch => {
        dispatch({
            type: SUPPORTER_PROJECT_REQUEST_DATA
        });
        axios(config.server.endpoint + 'backend/supporter/project/' + id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: SUPPORTER_PROJECT_RECEIVE_DATA,
                    data: response.data.data
                });
            } else if(response.status === 404) {
                dispatch({
                    type: SUPPORTER_PROJECT_RECEIVE_NOT_FOUND
                })
            }
        })
    }
}

export function toggleBooleanValue(name) {
    return {
        type: SUPPORTER_PROJECT_TOGGLE_BOOLEAN_VALUE,
        name
    }
}

export function toggleItemValue(key) {
    return {
        type: SUPPORTER_PROJECT_TOGGLE_ITEM_VALUE,
        key
    }
}

export function setItemValue(key, value) {
    return {
        type: SUPPORTER_PROJECT_SET_ITEM_VALUE,
        key,
        value
    }
}

export function changeValue(name, value) {
    return {
        type: SUPPORTER_PROJECT_CHANGE_VALUE,
        name,
        value
    }
}

export function editSupporterProject() {
    return {
        type: SUPPORTER_PROJECT_EDIT
    }
}

export function saveSupporterProject(data) {
    return dispatch => {
        dispatch({
            type: SUPPORTER_PROJECT_SEND_SAVE
        });
        axios(config.server.endpoint + 'backend/supporter/project/' + data.id, {
            method: 'put',
            data: {
                state: data.state,
                period: data.period,
                queuePeriod: data.queuePeriod,
                isFlexible: data.isFlexible,
                aborted: data.aborted,
                abortedReason: data.abortedReason,
                bestFriendsTicketAllowed: data.bestFriendsTicketAllowed,
                confirmShifts: data.confirmShifts,
                festivalWorkingDays: data.festivalWorkingDays,
                availableAsSteward: data.availableAsSteward,
                stewardFormReceived: data.stewardFormReceived,
                stewardNumber: data.stewardNumber,
                copiedToSputnik: data.copiedToSputnik,
                availableForBottleDeposit: data.availableForBottleDeposit,
                daysOffPreset: data.daysOffPreset,
                extraWorkingDay: data.extraWorkingDay,
                supporterGroup: data.supporterGroup,
                newGroupName: data.newGroupName,
                workTypes: data.workTypes,
                preferredBackstage: data.preferredBackstage,
                sleepingArrangement: data.sleepingArrangement,
                items: data.items
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch({
                        type: SUPPORTER_PROJECT_RECEIVE_SAVE,
                        data: response.data
                    });
                    dispatch(getSupporterProject(data.id));
                    EventBus.dispatch('SupporterEventsBlock-load', {});
                    EventBus.dispatch('SupporterTicketBlock-load', {});
                } else {
                    dispatch({
                        type: SUPPORTER_PROJECT_RECEIVE_SAVE_ERROR,
                        data: response.data
                    });
                }
            }
        });
    }
}
